function consumeCommonsIntegrityKeys(manifestInstance, libName) {
  const key = manifestInstance.commons.integrityKeys?.find(
    integrity => integrity.name === `${libName}.js`,
  )?.value

  return key
}

module.exports = {
  consumeCommonsIntegrityKeys,
}
